import firebase from "../../config/firebase";
const storage = firebase.storage();
const uploadFile = async (file, folder) => {
    if (file instanceof File) {
        const storageRef = storage.ref().child(`${folder}/${file.name}`);
        const uploadTask = await storageRef.put(file);
        return uploadTask.ref.getDownloadURL();
    }
    return null;
};

const Loader = (data) => async (dispatch) => {
    dispatch({
        type: "DRAFT_LOADER",
        payload: data,
    });
};

export const getAthleteMomentosDrafts =
    (lastDocument, uid, onSuccess = () => {}) =>
    async (dispatch) => {
        dispatch(Loader(true));
        try {
            console.log(uid);
            let query = firebase
                .firestore()
                .collection("momentos_draft")
                .where("athleteID", "==", uid)
                .where("isDeleted", "==", false)
                .orderBy("createdAt", "desc");
            if (lastDocument != "") {
                query = query.startAfter(lastDocument);
            }
            query.limit(5).onSnapshot((query) => {
                const myMomentos = [];
                for (let doc of query.docs) {
                    if (doc.exists) {
                        myMomentos.push({ id: doc.id, ...doc.data() });
                    }
                }
                let hasMoreDocuments = myMomentos.length >= 5;
                dispatch(Loader(false));
                if (lastDocument == "") {
                    dispatch({
                        type: "IS_DRAFT_EMPTY",
                        payload: {
                            data: myMomentos,
                            lastDocument: query.docs[myMomentos.length - 1],
                            hasMoreDocument: hasMoreDocuments,
                        },
                    });
                    onSuccess();
                } else {
                    dispatch({
                        type: "DRAFT_DATA",
                        payload: {
                            data: myMomentos,
                            lastDocument: query.docs[myMomentos.length - 1],
                            hasMoreDocument: hasMoreDocuments,
                        },
                    });
                    onSuccess();
                }
            });
        } catch (error) {
            onSuccess();
            dispatch(Loader(false));
            console.error("Error listening to momentos:", error);
        }
    };

export const createDraftMomentosAction =
    (uid, payload, onSuccess = () => {}) =>
    async (dispatch) => {
        const myMomentosData = [];
        dispatch(Loader(true));
        try {
            firebase
                .firestore()
                .collection("momentos_draft")
                .where("athlete_id", "==", uid)
                .onSnapshot((query) => {
                    for (let doc of query.docs) {
                        if (doc.exists) {
                            myMomentosData.push({ id: doc.id, ...doc.data() });
                        }
                    }
                });
            const { momento, qrCodes } = payload;
            const updatedMomento = await Promise.all(
                momento.map(async (item) => {
                    const mediaDownloadURL = await uploadFile(
                        item.media,
                        "momentos_draft"
                    );
                    item.media = mediaDownloadURL || item.media;

                    return item;
                })
            );
            const updatedQrCodes = await Promise.all(
                qrCodes.map(async (qrCode) => {
                    if (qrCode instanceof File) {
                        const qrCodeDownloadURL = await uploadFile(
                            qrCode,
                            "QRCode"
                        );
                        return qrCodeDownloadURL || qrCode;
                    }
                    return qrCode;
                })
            );
            await firebase
                .firestore()
                .collection("momentos_draft")
                .add({
                    ...payload,
                    private: false,
                    isDeleted: false,
                    createdAt: firebase.firestore.Timestamp.now(),
                    momento: updatedMomento,
                    qrCodes: updatedQrCodes,
                    momentoID: "",
                });

            dispatch(Loader(false));
            onSuccess();
        } catch (error) {
            dispatch(Loader(false));
            console.error("Error creating momentos:", error);
        }
    };

export const getSingleMomentoDraft = (id) => async (dispatch) => {
    firebase
        .firestore()
        .collection("momentos_draft")
        .doc(id)
        .get()
        .then((doc) => {
            dispatch({
                type: "SINGLE_DRAFT_MOMENTO",
                payload: { id: doc.id, ...doc.data() },
            });
        });
};

export const updateDraftMomento =
    (ID, payload, onSuccess = () => {}) =>
    async (dispatch) => {
        dispatch(Loader(true));
        try {
            const { momento, qrCodes } = payload;

            const updatedMomento = await Promise.all(
                momento.map(async (item) => {
                    const mediaDownloadURL = await uploadFile(
                        item.media,
                        "momentos_draft"
                    );
                    item.media = mediaDownloadURL || item.media;

                    return item;
                })
            );
            const updatedQrCodes = await Promise.all(
                qrCodes.map(async (qrCode) => {
                    if (qrCode instanceof File) {
                        const qrCodeDownloadURL = await uploadFile(
                            qrCode,
                            "QRCode"
                        );
                        return qrCodeDownloadURL || qrCode;
                    }
                    return qrCode;
                })
            );

            await firebase
                .firestore()
                .collection("momentos_draft")
                .doc(ID)
                .update({
                    ...payload,
                    momento: updatedMomento,
                    qrCodes: updatedQrCodes,
                })
                .then(dispatch(Loader(false)), onSuccess());
        } catch (error) {
            dispatch(Loader(false));
            console.error("An error occurred during update:", error);
        }
    };

export const deleteDraftMomento =
    (id, onSuccess = () => {}) =>
    async (dispatch) => {
        try {
            await firebase
                .firestore()
                .collection("momentos_draft")
                .doc(id)
                .update({
                    isDeleted: true,
                });

            onSuccess();
        } catch (error) {
            console.error("Error deleting momento:", error);
        }
    };
